import { render } from "./LabView.vue?vue&type=template&id=e44f3996&scoped=true"
import script from "./LabView.vue?vue&type=script&lang=js"
export * from "./LabView.vue?vue&type=script&lang=js"

import "./LabView.vue?vue&type=style&index=0&id=e44f3996&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44f3996"]])

export default __exports__